import axios from 'axios';
import {
  DIET_TEMPLATE_LIST_REQUEST, DIET_TEMPLATE_LIST_SUCCESS, DIET_TEMPLATE_LIST_FAIL,
  DIET_TEMPLATE_CREATE_REQUEST, DIET_TEMPLATE_CREATE_SUCCESS, DIET_TEMPLATE_CREATE_FAIL,
  DIET_TEMPLATE_UPDATE_REQUEST, DIET_TEMPLATE_UPDATE_SUCCESS, DIET_TEMPLATE_UPDATE_FAIL,
  DIET_TEMPLATE_DELETE_REQUEST, DIET_TEMPLATE_DELETE_SUCCESS, DIET_TEMPLATE_DELETE_FAIL,
  DIET_TEMPLATE_DETAILS_REQUEST, DIET_TEMPLATE_DETAILS_SUCCESS, DIET_TEMPLATE_DETAILS_FAIL,
  baseURL
} from './types';

const getAuthToken = () => {
  const loginData = JSON.parse(localStorage.getItem('loginData') || '{}');
  return loginData.token || '';
};

const config = () => ({
  headers: { 
    'Content-Type': 'application/json', 
    'Authorization': `Bearer ${getAuthToken()}` 
  }
});

// 1. List All Diet Templates
export const listDietTemplates = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: DIET_TEMPLATE_LIST_REQUEST });
    const { data } = await axios.post(`${baseURL}/api/appointmentDietTemplate/getall`, filters, config());
    dispatch({ type: DIET_TEMPLATE_LIST_SUCCESS, payload: data.data });
  } catch (error) {
    dispatch({ type: DIET_TEMPLATE_LIST_FAIL, payload: error.response?.data?.message || error.message });
  }
};

// 2. Create Diet Template
export const createDietTemplate = (templateData) => async (dispatch) => {
  try {
    dispatch({ type: DIET_TEMPLATE_CREATE_REQUEST });
    const { data } = await axios.post(`${baseURL}/api/appointmentDietTemplate/create`, templateData, config());
    dispatch({ type: DIET_TEMPLATE_CREATE_SUCCESS, payload: data });
    return Promise.resolve(data);
  } catch (error) {
    dispatch({ type: DIET_TEMPLATE_CREATE_FAIL, payload: error.response?.data?.message || error.message });
    return Promise.reject(error);
  }
};

// 3. Update Diet Template
export const updateDietTemplate = (templateData) => async (dispatch) => {
  try {
    dispatch({ type: DIET_TEMPLATE_UPDATE_REQUEST });
    const { data } = await axios.patch(`${baseURL}/api/appointmentDietTemplate/update`, templateData, config());
    dispatch({ type: DIET_TEMPLATE_UPDATE_SUCCESS, payload: data });
    return Promise.resolve(data);
  } catch (error) {
    dispatch({ type: DIET_TEMPLATE_UPDATE_FAIL, payload: error.response?.data?.message || error.message });
    return Promise.reject(error);
  }
};

// 4. Delete Diet Template
export const deleteDietTemplate = (id) => async (dispatch) => {
  try {
    dispatch({ type: DIET_TEMPLATE_DELETE_REQUEST });
    await axios.delete(`${baseURL}/api/appointmentDietTemplate/delete`, { ...config(), data: { id } });
    dispatch({ type: DIET_TEMPLATE_DELETE_SUCCESS, payload: id });
  } catch (error) {
    dispatch({ type: DIET_TEMPLATE_DELETE_FAIL, payload: error.response?.data?.message || error.message });
  }
};

// 5. Get Single Diet Template by ID
export const getDietTemplateById = (id) => async (dispatch) => {
  try {
    dispatch({ type: DIET_TEMPLATE_DETAILS_REQUEST });
    const { data } = await axios.post(`${baseURL}/api/appointmentDietTemplate/byid`, { id }, config());
    if (data.success) {
      dispatch({ type: DIET_TEMPLATE_DETAILS_SUCCESS, payload: data.data });
    }
  } catch (error) {
    dispatch({ type: DIET_TEMPLATE_DETAILS_FAIL, payload: error.response?.data?.message || error.message });
  }
};